import { useEffect } from "react";

export default function Login() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  useEffect(() => {
    document.title = "Iniciar sesión · Grabarte Cashflow";
  }, []);

  const err = new URLSearchParams(window.location.search).get("err");

  return (
    <div
      className="min-h-screen flex items-center justify-center paper-grain bg-[var(--bg)] p-6"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1601662528567-526cd06f6582?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwYWJzdHJhY3QlMjB3aGl0ZSUyMHBhcGVyJTIwdGV4dHVyZXxlbnwwfHx8fDE3Nzk2OTYzMjJ8MA&ixlib=rb-4.1.0&q=85')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="w-full max-w-md bg-white border border-[var(--border)] p-10" data-testid="login-card">
        <div className="mb-8">
          <div className="font-mono-num text-[10px] uppercase tracking-[0.25em] text-[var(--ink-muted)] mb-3">
            Grabarte · Panel financiero
          </div>
          <h1 className="font-display text-4xl font-black tracking-tight leading-none">
            Cashflow.
          </h1>
          <p className="mt-3 text-sm text-[var(--ink-muted)]">
            Sistema interno de gestión de tesorería. Acceso restringido a usuarios autorizados.
          </p>
        </div>

        {err && (
          <div
            data-testid="login-error"
            className="mb-6 border border-rose-300 bg-rose-50 text-rose-800 text-sm px-4 py-3 rounded"
          >
            <div className="font-semibold mb-0.5">No se pudo iniciar sesión</div>
            <div className="text-xs">{err}</div>
          </div>
        )}

        <button
          onClick={handleLogin}
          data-testid="login-google-button"
          className="w-full bg-black text-white py-3 text-sm font-medium tracking-wide hover:bg-gray-900 transition-colors flex items-center justify-center gap-3"
        >
          <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4C12.9 4 4 12.9 4 24s8.9 20 20 20s20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4C16.3 4 9.7 8.3 6.3 14.7z"/>
            <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.1C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.6 5.1C9.6 39.5 16.2 44 24 44z"/>
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.3-4.1 5.7l6.2 5.1C40.7 35.9 44 30.4 44 24c0-1.3-.1-2.4-.4-3.5z"/>
          </svg>
          Entrar con Google
        </button>

        <div className="mt-8 pt-6 border-t border-[var(--border)] text-[11px] text-[var(--ink-muted)] font-mono-num leading-relaxed">
          El primer usuario que inicie sesión se convertirá automáticamente en administrador.
          Los siguientes accesos requieren aprobación.
        </div>
      </div>
    </div>
  );
}
